import { notification } from 'antd'
import { ICrudUrl } from 'interfaces'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCreateEditService } from 'services'

const useCreateEdit = <T,>(searchQueryUrl: ICrudUrl) => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()
  const { postCreateItem, postEditItem, patchEditItem } =
    useCreateEditService<T>()

  const handleCreateItem = async (
    payload: T,
    messageSuccess: string,
    url?: string
  ) => {
    setLoading(true)
    const res = await postCreateItem(
      url || searchQueryUrl?.create || '',
      payload
    )
    setLoading(false)
    if (res._successfully) {
      notification.success({ message: t(messageSuccess) })
    }
    return res
  }

  const handleCreateItemParam = async (
    id: string,
    payload: T,
    messageSuccess?: string
  ) => {
    setLoading(true)
    const res = await postCreateItem(
      searchQueryUrl?.create?.replace(':id', id) || '',
      payload
    )
    setLoading(false)
    if (res._successfully && messageSuccess) {
      notification.success({ message: t(messageSuccess) })
    }
    return res
  }

  const handlePostEditItem = async (
    payload: T,
    messageSuccess?: string,
    url?: string
  ) => {
    setLoading(true)
    const res = await postEditItem(url || searchQueryUrl?.update || '', payload)
    setLoading(false)
    if (res._successfully && messageSuccess) {
      notification.success({ message: t(messageSuccess) })
    }
    return res
  }

  const handlePatchEditItem = async (
    payload: T,
    messageSuccess?: string,
    url?: string
  ) => {
    setLoading(true)
    const res = await patchEditItem(
      url || searchQueryUrl?.update || '',
      payload
    )
    setLoading(false)
    if (res._successfully && messageSuccess) {
      notification.success({ message: t(messageSuccess) })
    }
    if (!res._successfully) {
      // notification.error({ message: res._message })
    }
    return res
  }

  return {
    loading,
    handleCreateItem,
    handlePostEditItem,
    handlePatchEditItem,
    handleCreateItemParam
  }
}

export default useCreateEdit
